import comp from "./BarChartCustomizable";
export default comp;
